import React, { Component } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import RegisterForm from './forms/RegisterForm';

import {
    REGISTER_LOADED,
    REGISTER_UNLOADED,
    REGISTER_UPDATE_FIELD,
    REGISTER_CHECK_USERNAME,
    REGISTER_CHECK_EMAIL,
    REGISTER_CHECK_PASSWORD
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.register,
    appName: state.common.appName
});

const mapDispatchToProps = dispatch => ({
    onLoad: () =>
        dispatch({ type: REGISTER_LOADED }),
    onUnload: () =>
        dispatch({ type: REGISTER_UNLOADED }),
    onUpdateField: (key, value) =>
        dispatch({ type: REGISTER_UPDATE_FIELD, key, value }),
    onCheckUsername: (payload) =>
        dispatch({ type: REGISTER_CHECK_USERNAME, payload }),
    onCheckEmail: (payload) =>
        dispatch({ type: REGISTER_CHECK_EMAIL, payload }),
    onCheckPassword: (payload) =>
        dispatch({ type: REGISTER_CHECK_PASSWORD, payload })
});

class Register extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleCheckUsername = this.handleCheckUsername.bind(this);
        this.handleCheckEmail = this.handleCheckEmail.bind(this);
        this.handleCheckPassword = this.handleCheckPassword.bind(this);
    }

    componentWillMount() {
        this.props.onLoad();
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    handleCheckUsername(e) {
        this.props.onCheckUsername();
    }

    handleCheckEmail(e) {
        this.props.onCheckEmail();
    }

    handleCheckPassword(e) {
        this.props.onCheckPassword();
    }

    handleChange(e) {
        this.props.onUpdateField(e.target.name, e.target.value);
    }

    render() {
        const username = this.props.username || '';
        const email = this.props.email || '';
        const password = this.props.password || '';
        const password2 = this.props.password2 || '';

        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="6">
                            <Card className="mx-4">
                                <CardBody className="p-4">
                                    <h1>Register</h1>
                                    <p className="text-muted">Create your account</p>

                                    <RegisterForm
                                        handleChange={this.handleChange}
                                        handleCheckUsername={this.handleCheckUsername}
                                        handleCheckEmail={this.handleCheckEmail}
                                        handleCheckPassword={this.handleCheckPassword}
                                        username={username} email={email} password={password} password2={password2} />

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register);


// WEBPACK FOOTER //
// ./src/containers/Register.js